import { render, staticRenderFns } from "./CarDocumentCreateForm.vue?vue&type=template&id=a85c4a96&scoped=true&"
import script from "./CarDocumentCreateForm.vue?vue&type=script&lang=js&"
export * from "./CarDocumentCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./CarDocumentCreateForm.vue?vue&type=style&index=0&id=a85c4a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85c4a96",
  null
  
)

export default component.exports